<template>
  <div class="article-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索标题" class="search" clearable />
      <el-button type="primary" @click="loadList">搜索</el-button>
      <el-button type="primary" @click="goCreate">添加文章</el-button>
    </div>
    <el-table :data="list" style="width:100%" stripe>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="category_id" label="分类" width="80" />
      <el-table-column prop="status" label="状态" width="80">
        <template #default="{row}">
          <el-tag :type="row.status ? 'success' : 'info'">
            {{ row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"
    />

  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import request from '../../utils/request'
import store from '../../store'

const router = useRouter()
const list = ref([])
const pagination = ref({ page: 1, pageSize: 20, total: 0 })
const keyword = ref('')


const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize, keyword: keyword.value }
  try {
    const data = await request.get('/v1/article/list', { params })
    list.value = data.list
    pagination.value.total = data.pagination.total
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const pageChange = (p) => {
  pagination.value.page = p
  loadList()
}

const goCreate = () => {
  router.push('/article/edit')
}

const edit = (row) => {
  router.push(`/article/edit/${row.id}`)
}

const remove = async (row) => {
  try {
    await request.post('/v1/article/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

onMounted(() => {
  if (store.state.token) {
    loadList();
  } else {
    watch(
      () => store.state.token,
      (t) => t && loadList(),
      { immediate: true }
    )
  }
})
</script>

<style scoped>
.article-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.search { width: 200px; }
.pager { margin-top: 15px; text-align: right; }
</style>
